import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="header">
        <h1>ICA Mobile app</h1>
        <p className="subtitle">Complete guide to using our mobile application</p>
      </header>
      
      <main className="main-content">
        <div className="container">
          <section className="section">
            <h2>Getting Started</h2>
            <p>
              Welcome to our mobile app! This manual will guide you through all the features and functionality 
              of the application. Whether you're a new user or looking to explore advanced features, 
              this guide has everything you need to get the most out of your experience.
            </p>
          </section>

          <section className="section">
            <h2>Installation</h2>
            <p>
              To install the app on your device:
            </p>
            <ol>
              <li>Open your device's app store (Google Play Store for Android or App Store for iOS)</li>
              <li>Search for "YMS mobile"</li>
              <li>Tap "Install" or "Get" to download the app</li>
              <li>Once installed, tap the app icon to open it</li>
            </ol>
          </section>

          <section className="section">
            <h2>Account Setup</h2>
            <p>
              Setting up your account is quick and easy:
            </p>
            <ol>
              <li>Scan the QR code from one of our stations, and enter your phone number</li>
              <li>You will receive an sms with a verification code</li>
              <li>Type the verification code into the app</li>
              <li>You're ready to start using the app!</li>
            </ol>
          </section>

          <section className="section">
            <h2>Main Features</h2>
            
            <h3>Navigation</h3>
            
            <ul>
              <li><strong>Home / find order:</strong> Enter plate and an order number</li>
              <li><strong>Visit overview:</strong> List of your orders, add or remove orders. Or start your visit.</li>
              <li><strong>Instruction page:</strong> View your current or past instructions. Complete specific order, or complete the entire visit.</li>
              <li><strong>Profile:</strong> Manage your account and preferences</li>
            </ul>

            <h3>Settings</h3>
            <p>
              Customize your app experience through the profile page:
            </p>
            <ul>
              <li>Account management</li>
            </ul>
          </section>


          <section className="section">
            <h2>Tips and Best Practices</h2>
            <ul>
              <li><strong>Keep open when using:</strong> Make sure to keep the app open while using it for the best experience</li>
              <li><strong>Keep the app updated:</strong> Regular updates include new features and security improvements</li>
              <li><strong>Enable notifications:</strong> Stay informed about important updates and activities</li>
             
            </ul>
          </section>

          <section className="section">
            <h2>Troubleshooting</h2>
            <h3>App Won't Load</h3>
            <p>
              If the app isn't loading properly:
            </p>
            <ol>
              <li>Check your internet connection</li>
              <li>Close and restart the app</li>
              <li>Update to the latest version</li>
              <li>Restart your device if necessary</li>
            </ol>
          </section>

          <section className="section">
            <h2>Contact Support</h2>
            <p>
              If you need additional help or have questions not covered in this manual:
            </p>
            <ul>
              <li><strong>Email:</strong> support@ICA.com</li>
              <li><strong>Help Center:</strong> Visit our online help center for FAQs and guides</li>
            </ul>
            <p>
              Our support team is available Monday through Friday, 9 AM to 5 PM.
            </p>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Dopago ApS. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
